import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 9.5h-0.75V6.75A6.75 6.75 0 0 0 5.53 4.81a1.25 1.25 0 0 0 2.4 0.72 4.25 4.25 0 0 1 8.32 1.22V9a0.5 0.5 0 0 1 -0.5 0.5H4.5a2 2 0 0 0 -2 2V22a2 2 0 0 0 2 2h15a2 2 0 0 0 2 -2V11.5a2 2 0 0 0 -2 -2Zm-9.5 6a2 2 0 0 1 4 0 2 2 0 0 1 -1 1.72v2.28a1 1 0 0 1 -2 0v-2.28a2 2 0 0 1 -1 -1.72Z",
  fill: "#211f58",
  "stroke-width": "1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'lockedIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  size: {
    type: Number as PropType<number>,
    default: 24,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})